import Vue from 'vue'
import store from '@/store'

// vuex-i18n
import vuexI18n from 'vuex-i18n'
import translateEn from '@/lang/en.json' // Import English Translation
import translateZn from '@/lang/zh.json' // Import Traditional Chinese Translation
Vue.use(vuexI18n.plugin, store, {
  moduleName: 'i18n',
  onTranslationNotFound (locale, key) {
    console.warn(`i18n :: Key '${key}' not found for locale '${locale}'`);
  }
});
Vue.i18n.add('en', translateEn); // Add English Translation
Vue.i18n.add('zh', translateZn); // Add Traditional Chinese Translation
Vue.i18n.set('en'); // Set default locale
